export const CHANGEPROJECT = "CHANGEPROJECT";

export const changeProject = () => ({
  type: CHANGEPROJECT,
});